import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import constants from '../../utils/constants';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { parse, format, isValid } from 'date-fns';

const index = ({ value, className, mode, disabled, id, name, help, onChange, design, view, mandatory }) => {

  const handleChange = (date) => {
    if (date instanceof Date && isValid(date)) {
      const year = date.getFullYear();
      if (year >= 1000) {
        const formatted = format(date, 'yyyy-MM-dd');
        onChange(formatted);
      } else {
        onChange(null);
      }
    } else {
      onChange(null);
    }
  };

  const parsedDate = value ? parse(value, 'yyyy-MM-dd', new Date()) : null;

  const inputWidth = "9ch";
  const minWidth = "9ch";

  return (
    <ThemeProvider theme={constants.CUSTOM_MUI_TEXT_FIELD_THEME}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>

        <Tooltip title={help} placement="top">
          <DatePicker
            label={design !== 'table' ? <span>
              {name}
              {mandatory ? <span style={{ color: 'red' }}> *</span> : ''}
            </span> : null}
            disabled={disabled}
            value={parsedDate}
            onChange={handleChange}
            inputFormat="dd/MM/yyyy"
            renderInput={(params) => (
              <TextField
                {...params}
                id={id}
                className={className ?? undefined}
                InputLabelProps={{
                  ...params.InputLabelProps,
                  shrink: true,
                  style: { fontSize: "inherit", lineHeight: "inherit" }
                }}
                inputProps={{
                  ...params.inputProps,
                  readOnly: mode,
                  placeholder: 'dd/mm/aaaa',
                  style: {
                    ...params.inputProps.style,
                    height: '1px',
                    minWidth,
                    width: inputWidth,
                    fontSize: "inherit",
                    fontWeight: '600',
                    lineHeight: "inherit",
                    paddingRight: "0px",
                    paddingLeft: "8px",
                    fontVariantNumeric: 'tabular-nums',
                  }
                }}
              />
            )}
          />
        </Tooltip>
      </LocalizationProvider>

    </ThemeProvider>
  );
};

export default index;
